import Page from "../../components/Page";
import useParticipantPage from "./hooks/useParticipantPage";

const ParticipantPage = () => {
  const page = useParticipantPage();
  return <Page {...page} />;
};

export default ParticipantPage;
